export default {
  currentPlatform: null,
  addingSteps: false,
  deletingSteps: false,
  savingStepOrder: false,
    unpublishingChallenge: false,
    platformsBeingUnpublished: [],
    platformsBeingPublished: [],
    platformsBeingValidated: [],
    showUnpublishChallengeStatusModal: false
};



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/initialState.js